import { Component, OnInit, ViewChild, Inject, DOCUMENT } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from './core/helpers/loader.service';
import { Router, NavigationEnd } from '@angular/router';
import { GaService } from './core/helpers/ga.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LocalizationService } from './core/helpers/localization.service';
import { CoreService } from './core/helpers/core.service';
import { DataServiceService } from './core/helpers/data-service.service';



@Component({
    selector: 'loyaltic-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'loyaltic';
  public loading = false;
  currentLang = 'en';
  showLocalizationPopup = false;
  showSettingIcon = false;
  isLiveUrl = false;
  cookieScriptUrl = '';
  date = new Date();
  // isComingSoon = true;
  lockview = false;
  // make isComingSoon & lockview  true while using coming-soon logic this has made false only for template
  isComingSoon = false;
  //lockview = false;
  mySubscription:any;
  isGeoRestricted = false;
  geoRestrictionMessage = 'This service is unavailable in your current location.';


  @ViewChild('localizationPopup', { static: false }) localizationPopupRef: any;
  public modalRef: BsModalRef;
  popupConfig = {
    ignoreBackdropClick: true,
    class: 'lyltc win modal-md modal-dialog-left',
  };

  constructor(public translate: TranslateService,
    private loader: LoaderService,
    private router: Router,
    private modalService: BsModalService,
    private localizationService: LocalizationService,
    public gaService: GaService,
    private coreService: CoreService,
    private dataService: DataServiceService,
    @Inject(DOCUMENT) private doc: any
    ) {

    translate.addLangs(['en-En', 'fi-FI', 'sv-SE', 'nb-NO', 'da-DK']);

    translate.setDefaultLang('fi-FI');
    this.dataService.checkisFacebookApp();
    //if (window.location.href.toLowerCase().indexOf('swehalsko21-se.azurewebsites.net') > -1 || window.location.href.toLowerCase().indexOf('kampanj.halsanskok.se') > -1) {
    //  translate.setDefaultLang('sv-SE');
    //}
    //else if (window.location.href.toLowerCase().indexOf('swehalsko21-fi.azurewebsites.net') > -1 || window.location.href.toLowerCase().indexOf('kampanja.halsanskok.fi') > -1) {
    //  translate.setDefaultLang('fi-FI');
    //}
    //else if (window.location.href.toLowerCase().indexOf('swehalsko21-dk.azurewebsites.net') > -1 || window.location.href.toLowerCase().indexOf('kampanje.halsanskok.ne') > -1) {
    //  translate.setDefaultLang('da-DK');
    //}
    //else if (window.location.href.toLowerCase().indexOf('swehalsko21-no.azurewebsites.net') > -1 || window.location.href.toLowerCase().indexOf('kampagne.halsanskok.dk') > -1) {
    //  translate.setDefaultLang('nb-NO');
    //}

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.mySubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
         // Trick the Router into believing it's last link wasn't previously loaded
         this.router.navigated = false;
      }
    });
    // Previously initialized Azure AD authentication; legacy ADAL integration removed.
  }

  ngOnInit(): void {
    //this.loadScript()   // uncomment once GA is added 
    //this.addBodyScript();
    this.checkComingSoon();
    this.showSettingIcon = false;

    this.translate.get('cookie-script').subscribe((translatedString) => {
      this.cookieScriptUrl = translatedString;
      this.loadCookieScript(this.cookieScriptUrl);
    }, error=> {
      console.log(error)
    });

    this.loader.getInputChangeLoaderEmitter().subscribe((res: any) => {
      this.loading = res;
    });

    this.router.events.forEach(item => {
      if (item instanceof NavigationEnd) {
        const gtmTag = {
          event: 'page',
          pageName: item.url
        };
        this.gaService.emitEvent('page', item.url);
      }
    });
  }

  changeLanguage(lang: string) {
    this.translate.setDefaultLang(lang);
    this.translate.use(lang).subscribe({
      error: (err) => console.error('Failed to switch language', err)
    });
  }

  showLocalizations() {
    this.showLocalizationPopup = true;
    this.modalRef = this.modalService.show(this.localizationPopupRef, this.popupConfig);
  }

  async checkComingSoon() {
    const hostname = window.location.hostname;
    // Api call for golive
    // let response = await this.liveconfig();
    await this.coreService.getLiveConfig().then((response: any) => {
      const goLiveDateString = response.result.liveDate;
      const goLiveDate = new Date(goLiveDateString);
      this.coreService.campaignStart = response.result.campaignStart;
      this.coreService.campaignEnd = response.result.campaignEnd;
      console.log("goLiveDate", this.coreService.campaignStart)

      response.result.liveUrls.forEach(element => {
          if (hostname.toLowerCase().indexOf(element) != -1){
          this.isLiveUrl = true;
        }

      });
      if (goLiveDate > this.date && this.isLiveUrl && !window.location.href.includes('localhost')) {
        console.log("show comin soon page")
        this.lockview = false
        this.isComingSoon = true;
        //this.router.navigate(['coming-soon'])
      } else {
        this.lockview = false
        this.isComingSoon = false;
      }

    }).catch((error) => {
      // Handle geo-restriction error
      if (error.status === 403 && error.error?.message === 'This service is only available from Finland.') {
        console.log('Geo-restriction detected');
        this.isGeoRestricted = true;
        this.lockview = false;
        this.isComingSoon = false;
      } else {
        console.error('Error fetching live config:', error);
      }
    });
  }

  loadCookieScript(cookieScript: string) {
    if (!cookieScript || cookieScript === 'cookie-script') {
      console.warn('Cookie script translation missing or empty');
      return;
    }

    const parsed = new DOMParser().parseFromString(cookieScript, 'text/html');
    const scriptEl = parsed.querySelector('script[src]');

    if (!scriptEl) {
      console.warn('Cookie script markup missing <script src="..."> element', cookieScript);
      return;
    }

    const src = scriptEl.getAttribute('src');
    if (!src) {
      console.warn('Cookie script element missing src attribute', cookieScript);
      return;
    }

    const dynamicScript = document.createElement('script');
    dynamicScript.type = 'text/javascript';
    dynamicScript.charset = 'UTF-8';
    dynamicScript.src = src;
    document.body.appendChild(dynamicScript);
  }


}
